import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, UncontrolledTooltip, Modal, ModalHeader, ModalBody, ModalFooter, Label, Badge } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DataEmptyState from '../../commons/dataemptystate';
import NetworkEmptyState from '../../commons/networkemptystate';
import Loader from '../../commons/loader';
import Services from './services';
import { PaginationTotal, FileCard } from '../../commons/controls';
import { ProgressButton } from '../../commons/ProgressButton';
import RFForm from '../../components/Form/RFForm';
import RFField from '../../components/Form/RFField';
import SelectField from '../../components/Form/SelectField';
import Lib from '../../commons/lib';

class KategoriaKezeles extends Component {
    constructor(props){
        super(props);
        this.state ={
            // ['LOAD', 'DATA', 'NETW', 'TABL']
            tableStatus: 'TABL',
            // ['LOAD', 'DATA', 'NETW']
            formStatus: 'DATA',
            // ['FEL', 'MOD']
            formType: 'FEL',
            // MODAL
            modalForm: false,
            modalDelete: false,
            // BUTTON
            saveButtonLoading: false,
            deleteButtonLoading: false,
            // DATA
            kategoriakJson: [],
            kategoriaObj: {},
            formKatHelyszin: [],
            kategoriaHelszinek: [],
            torlesId: null,
            angolNyelv: false,

            statusz: [],
            statuszOptions: [],
            filterOptions: {},
        }
    }

  componentDidUpdate(prevProps) {
    if (this.props.active !== prevProps.active) {
      if (this.props.active) {
        this.checkAngolNyelv();
        this.listKategoriak();
        }
      }
    }

    hasRole = (roles, checkKarb) => {
      return this.props.globals.hasRole(roles, checkKarb);
    }

    listKategoriak = () => {
        Services.listKategoriak((err, res) => {
            if (!err) {
              let filters = {};
              let options = res[0].statusz.map((e) => {
                filters[e.name] = e.caption;

                return <option key={e.name} value={e.name}>{e.caption}</option>;
              });

              this.setState({
                kategoriakJson: res[0].list,
                tableStatus: res[0].list.length > 0 ? 'TABL' : 'DATA',
                statusz: res[0].statusz,
                statuszOptions: options,
                filterOptions: filters,
              });
            } else {
              this.setState({
                tableStatus: 'NETW'
              });
            }
          });
    }

    initKategoria = (isNew) => {
      Services.initKategoriak((err, res) => {
        if (!err) {
          let katHelyszinek = [];
          for (const [key, value] of Object.entries(res[0].helyszin)) {
            katHelyszinek.push({ label: value, value: key })
          }
          if (isNew) {
            this.setState({ formKatHelyszin: [] });
          }
          this.setState({
            helyszinek: katHelyszinek,
          });
        }
      })
    }

    getKategoria = (cell) => {
        this.setState({ formStatus: 'LOAD' });
        const nullToEmpty = (data) => {
          if (data == null) return '';
          return data;
        }
   
        Services.getKategoria(cell, (err, res) => {
            if (!err) {
                let helyszinek = [];
                for (const [key, value] of Object.entries(res[0].helyszin)) {
                    res[0].helyszinids.forEach((elem) => {
                      if (parseInt(key, 10) === elem) {
                        helyszinek.push({ label: value , value: key})
                      }
                    });  
                  }
                  res[0].kategoria.statusz = res[0].kategoria.statusz.name
                  res[0].kategoria.nevAngol = nullToEmpty(res[0].kategoria.nevAngol);
                  res[0].kategoria.megjegyzes = nullToEmpty(res[0].kategoria.megjegyzes);
                  res[0].kategoria.megjegyzesAngol = nullToEmpty(res[0].kategoria.megjegyzesAngol);
                this.setState({
                    formStatus: 'DATA',
                    kategoriaObj: res[0].kategoria,
                    formKatHelyszin: helyszinek
                });
            }
        })
    }

    checkAngolNyelv = () => {
      Services.getAngolNyelv((err, res) => {
        if (!err) {
          this.setState({ angolNyelv: res[0] });
        }
      });
    }

    angolEngedelyezve = () => {
      return this.state.angolNyelv == true;
    }
  
    toggleModalForm = () => {
        this.setState((prevState) => ({ modalForm: !prevState.modalForm }));
    }

    toggleModalDeleteForm = () => {
        this.setState((prevState) => ({ modalDelete: !prevState.modalDelete }));
    }

    deleteKategoria = () => {
        let id = this.state.torlesId;
        this.setState({ deleteButtonLoading: true });
        Services.deleteKategoria(id, (err) => {
            if (!err) {
                this.setState({ deleteButtonLoading: false, deleteId: null });
                this.toggleModalDeleteForm();
                this.listKategoriak();
                this.props.globals.addSuccess('Kategória sikeresen törölve!');
            }
            this.setState({ deleteButtonLoading: false });
        });
    }

    handleNewClick = () => {
      this.initKategoria(true);

      this.setState({
        formType: 'FEL',
        modalForm: true,
        kategoriaObj: { statusz: 'AKTIV' },
        formKatHelyszin: []
      });
    }

    handleEditClick = (cell) => {
      this.initKategoria();
      this.setState({
        formType: 'MOD',
        modalForm: true
      });
      this.getKategoria(cell);
    }

    handleDeleteClick = (cell) => {
      this.setState({
        torlesId: cell
      }, () => {
        this.toggleModalDeleteForm();
      });
    }

    handleInputChange = (e) => {
      const emptyOrNull = (data) => {
        if (!data || data === '') return null;
        return data;
      }
      let newObj = this.state.kategoriaObj;
      if (e.target.name === "publikus"){
        newObj[e.target.name] = e.target.checked;
      } else {
        newObj[e.target.name] = emptyOrNull(e.target.value);
      }
      this.setState({
        kategoriaObj: newObj
      });
    }

    renderFormTitle = () => {
        const { formType } = this.state;
        if (formType === 'FEL') {
            return 'Új kategória hozzáadása';
        }
        if (formType === 'MOD') {
            return 'Kategória módosítása';
        }
    }

    renderForm = () => {
        // const {
        //     formNev,
        //     formAzonosito,
        //     formKatHelyszin,
        //     formMegjegyzes,
        //     formPublikus,
        //     formStatusz,
        //     formType
        //   } = this.state;

        const { kategoriaObj, formType, formKatHelyszin } = this.state;
        const className = this.state.angolNyelv===true ? "col-md-4" : "col-md-6";
          return (
            <React.Fragment>
                <div className={className}>
                  <RFField
                    type="text"
                    label="Azonosító: *"
                    name="azonosito"
                    id="azonosito"
                    value={kategoriaObj.azonosito}
                    onChange={(e) => this.handleInputChange(e)}
                    disabled={formType === 'MOD'}
                    required
                  />
                </div>
                <div className={className}>
                  <RFField
                    type="text"
                    label="Kategória neve: *"
                    name="nev"
                    id="nev"
                    value={kategoriaObj.nev}
                    onChange={(e) => this.handleInputChange(e)}
                    required
                  />
                </div>
                {this.angolEngedelyezve() && 
                <div className={className}>
                  <RFField
                    type="text"
                    label="Kategória neve (angol):"
                    name="nevAngol"
                    id="nevAngol"
                    value={kategoriaObj.nevAngol}
                    onChange={(e) => this.handleInputChange(e)}
                  />
                </div>
                }
                <div className={className}>
                    <SelectField
                      label='Helyszín(ek):'
                      name="formKatHelyszin"
                      id="formKatHelyszin"
                      onChange={v => {
                        if ([...this.state.formKatHelyszin].filter(regiHelyszin => !v.includes(regiHelyszin)).some(helyszinOption => !this.state.helyszinek.map(h => h.value).includes(helyszinOption.value))) {
                          this.props.globals.addWarning('A törlés nem hajtható végre, mert a felhasználó nem rendelkezik az adott helyszín szerepkörével!');
                          return;
                        }
                        this.setState({formKatHelyszin: v})
                      }}
                      placeholder={'Válassz helyszín(eke)t...'}
                      isMulti
                      options={this.state.helyszinek}
                      value={formKatHelyszin}
                    />
                </div>
                <div className={className}>
                  <RFField
                    type="text"
                    label="Megjegyzés:"
                    name="megjegyzes"
                    id="megjegyzes"
                    value={kategoriaObj.megjegyzes}
                    onChange={(e) => this.handleInputChange(e)}
                  />
                </div>
                {this.angolEngedelyezve() && 
                <div className={className}>
                  <RFField
                    type="text"
                    label="Megjegyzés (angol):"
                    name="megjegyzesAngol"
                    id="megjegyzesAngol"
                    value={kategoriaObj.megjegyzesAngol}
                    onChange={(e) => this.handleInputChange(e)}
                  />
                </div>
                }
                <div className={className}>
                  <RFField
                    type="select"
                    name="statusz"
                    id="statusz"
                    label="Státusz: "
                    value={kategoriaObj.statusz}
                    onChange={(e) => this.handleInputChange(e)}
                    selectOptions={this.state.statuszOptions}
                    />
                </div>
                <div className={className + " align-self-center"}>
                  <RFField
                    name="publikus"
                    label="Publikus?"
                    type="checkbox"
                    value={!!kategoriaObj.publikus}
                    onChange={(e) => this.handleInputChange(e)}
                  />
                </div>
            </React.Fragment>
          );
    }

    submitForm = (e, submitObj) => {
        const { formType } = this.state;
        submitObj = { ...submitObj, ...this.state.kategoriaObj };
        submitObj.statusz = submitObj.statusz ? submitObj.statusz : 'AKTIV';
        submitObj.publikus = !!submitObj.publikus;
        let helyszinek = [];
        this.state.formKatHelyszin.forEach((hely) => helyszinek.push(parseInt(hely.value, 10)));
        submitObj.helyszinids = helyszinek;
        this.setState({ saveButtonLoading: true });
        if (formType === 'FEL') {
            Services.addKategoria(submitObj, (err) => {
                if (!err) {
                    this.setState({ saveButtonLoading: false });
                    this.toggleModalForm();
                    this.listKategoriak();
                    this.props.globals.addSuccess('Kategória sikeresen hozzáadva!');
                } else {
                    this.setState({ saveButtonLoading: false });
                }
            })
        }
        if (formType === 'MOD') {
            Services.editKategoria(submitObj, (err) => {
                if (!err) {
                    this.setState({ saveButtonLoading: false });
                    this.toggleModalForm();
                    this.listKategoriak();
                    this.props.globals.addSuccess('Kategória sikeresen módosítva!');
                } else {
                    this.setState({ saveButtonLoading: false });
                }
            })
        }
    }

    statusFormatter = (cell) => {
      let statusz = this.state.statusz.find(x => x.name === cell);
      return statusz ? <span className={'badge badge-' + statusz.bagde}>{statusz.caption}</span> : 'N/A';
    }

    publikusFormatter = (cell, row) => {
      if (row.azonosito) {
          if (cell === true) {
              return <Badge color="success">{'Igen'}</Badge>
          }
          if (cell === false) {
          return <Badge color="danger">{'Nem'}</Badge>
          }
      } else {
          return <span>Mindig aktív</span>
      }
  }

    
  tableIconFormatter = (cell, row) => {
    return (
      <div>
        <React.Fragment>
          {this.hasRole(['HIRLEVEL_HIRLEVEL'], true) && row.azonosito && (
            <React.Fragment>
                <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
                    {'Módosítás'}
                </UncontrolledTooltip>
                <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'file'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'file'} delay={50}>
                    {'Törlés'}
                </UncontrolledTooltip>
            </React.Fragment>
          )}
        </React.Fragment>
      </div>
    );
  }

    renderTable = () => {
          const publikusOptions = [
            {
              label: 'Igen',
              value: true
            },
            {
              label: 'Nem',
              value: false
            }
          ];

          const columns = [
            {
              dataField: 'azonosito',
              text: 'Azonosító',
              filter: textFilter({
                delay: 400, // default is 500ms
                placeholder: 'Keresés...',
              }),
              style: {
                wordBreak: 'break-all',
                whiteSpace: 'pre-line',
              },
              sort: true
            },
            {
              dataField: 'nev',
              text: 'Kategória',
              filter: textFilter({
                delay: 400, // default is 500ms
                placeholder: 'Keresés...',
              }),
              style: {
                wordBreak: 'break-all',
                whiteSpace: 'pre-line',
              },
              sort: true
            },
            {
              dataField: 'helyszin',
              text: 'Helyszín(ek)',
              filter: textFilter({
                delay: 400, // default is 500ms
                placeholder: 'Keresés...',
              }),
              style: {
                wordBreak: 'break-all',
                whiteSpace: 'pre-line',
              },
              sort: true
            },
            {
              dataField: 'publikus',
              text: 'Publikus',
              align: 'center',
              filter: selectFilter({
                options: publikusOptions,
                placeholder: 'Összes'
              }),
              // filter: textFilter({
              //   delay: 400, // default is 500ms
              //   placeholder: 'Keresés...',
              // }),
              formatter: this.publikusFormatter,
              style: {
                wordBreak: 'break-all',
                whiteSpace: 'pre-line',
              },
              sort: true
            },
            {
              dataField: 'statusz',
              text: 'Statusz',
              align: 'center',
              filter: selectFilter({
                options: this.state.filterOptions,
                placeholder: 'Összes'
              }),
              // filter: textFilter({
              //   delay: 400, // default is 500ms
              //   placeholder: 'Keresés...',
              // }),
              formatter: this.statusFormatter,
              style: {
                wordBreak: 'break-all',
                whiteSpace: 'pre-line',
              },
              sort: true
            },
            {
              dataField: 'megjegyzes',
              text: 'Megjegyzés',
              filter: textFilter({
                delay: 400, // default is 500ms
                placeholder: 'Keresés...',
              }),
              style: {
                wordBreak: 'break-all',
                whiteSpace: 'pre-line',
              },
              sort: true
            },
            {
              dataField: 'id',
              text: 'Műveletek',
              hidden: !this.hasRole(['HIRLEVEL_HIRLEVEL'], true),
              formatter: (cell, row) => this.tableIconFormatter(cell, row)
            }
          ];
          return (
            <div className="animated fadeIn">
              <BootstrapTable
                bootstrap4
                keyField="id"
                data={this.state.kategoriakJson}
                columns={columns}
                wrapperClasses="table-responsive"
                classes="table-scroll"
                headerClasses="table-th"
                filter={filterFactory()}
                pagination={paginationFactory(Lib.bootstraptableProps)}
                noDataIndication="Nincs megjelenítendő adat!"
              />
            </div>
          );
    }

    render() {
        return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-12">
                {this.hasRole(['HIRLEVEL_HIRLEVEL'], true) && (
                <Button onClick={() => this.handleNewClick()} color="primary">Új kategória hozzáadása</Button>
                )} 
                </div>
                <br /><br />
                <div className="col-md-12" />
                <div className="col-md-12">
                {{
                    LOAD: (<Loader />),
                    DATA: (<DataEmptyState
                    hasImage
                    subtitle="Vigyél fel új tételt!"
                    />),
                    NETW: (<NetworkEmptyState
                    hasImage
                    submitClick={() => { this.listLeiratkozasok() }}
                    />),
                    TABL: (this.renderTable())
                }[this.state.tableStatus]
                }
                </div>
            </div>
            <Modal isOpen={this.state.modalForm} toggle={this.toggleModalForm} backdrop="static" size="lg">
              <RFForm
                modal
                onSubmit={this.submitForm}
                title={this.renderFormTitle()}
                footer={
                  <React.Fragment>
                    <ProgressButton
                    className="btn-cursor-pointer"
                    color="primary"
                    loading={this.state.saveButtonLoading}
                    >
                    {'Mentés'}
                    </ProgressButton>
                    <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleModalForm}>Mégsem</Button>
                  </React.Fragment>
                }
              >
                <div className="row">
                  {this.renderForm()}
                </div>
              </RFForm>
            </Modal>
            <Modal isOpen={this.state.modalDelete} toggle={this.toggleModalDeleteForm} backdrop="static">
                <ModalHeader>Törlés</ModalHeader>
                <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
                <ModalFooter>
                <ProgressButton
                    className="btn-cursor-pointer"
                    color="primary"
                    onClick={() => this.deleteKategoria()}
                    loading={this.state.deleteButtonLoading}
                >
                    {'Igen'}
                </ProgressButton>
                <Button type="button" color="secondary" onClick={this.toggleModalDeleteForm}>Mégsem</Button>
                </ModalFooter>
            </Modal>
        </React.Fragment>
        );
    }
}

KategoriaKezeles.propTypes = {
  globals: PropTypes.object,
  type: PropTypes.string,
  active: PropTypes.bool,
};

export default KategoriaKezeles;